import { IconButton } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import api from '../api/api';
import { getPracticeId } from '../config/practice';

const UserDelete = ({ DeleteModalClose, userrowId,fetchUsersData }) => {
  const [loading, setLoading] = useState(false);
  const practiseid = getPracticeId();
  console.log("No user ID provided!", userrowId);

  // Function to handle the API call for deleting the user
  const handleDelete = async (userrowId) => {
    if (!userrowId) {
        console.log("No user ID provided!");
      return;
    }

    setLoading(true); // Start loading

    try {
      // Call the API to delete the user
      const response = await api.delete(`/v1/${practiseid}/user/${userrowId.id}`);
      
      if (response.status === 200) {
        console.log("User deleted successfully!");
        fetchUsersData()
        DeleteModalClose();  // Close the modal after deletion
      } else {
        console.log("Failed to delete user. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      console.log("An error occurred while deleting the user.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
      {/* Popup Box */}
      <div className="relative flex flex-col w-[30%] bg-white pb-2 p-3 rounded-lg shadow-lg text-left">
        <div className="flex justify-between items-center border-b pb-2">
          <h3 className="font-semibold text-lg">Are you sure?</h3>
          <IconButton onClick={DeleteModalClose} className="text-gray-600 hover:text-gray-700">
            <CloseIcon fontSize="medium" />
          </IconButton>
        </div>
        <h3 className="font-inter my-4 text-lg">Do you want to delete this user?</h3>

        <div className="flex justify-between mt-4">
          {/* Cancel Button */}
          <button
            onClick={DeleteModalClose}
            className="py-2 px-4 bg-gray-100 rounded-lg text-gray-700 hover:bg-gray-200"
          >
            Cancel
          </button>

          {/* Yes Button - Delete User */}
          <button
            onClick={()=>handleDelete(userrowId)}
            disabled={loading}
            className={`py-2 px-4 ${loading ? 'bg-gray-400' : 'bg-red-600'} text-white rounded-lg hover:bg-red-700`}
          >
            {loading ? 'Deleting...' : 'Yes, Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDelete;
